/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { RubricRowBaseInputBaseAsJSON } from './RubricRowBaseInputBaseAsJSON';
const PatchRubricCategoryTypeAssignmentDataParser = 
/* #__PURE__ */ parsers.object([
    ['newType', /* #__PURE__ */ parsers.exactly('normal', 'continuous'), 'new_type'],
    ['row', RubricRowBaseInputBaseAsJSON],
]);
export class PatchRubricCategoryTypeAssignmentData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PatchRubricCategoryTypeAssignmentDataParser.decode(input).map(res => new PatchRubricCategoryTypeAssignmentData(res));
    }
    static unsafeDecode(input) {
        return PatchRubricCategoryTypeAssignmentData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PatchRubricCategoryTypeAssignmentDataParser.encode(data);
    }
    static schema() {
        return PatchRubricCategoryTypeAssignmentDataParser.schema();
    }
}
